import(/* webpackMode: "eager", webpackExports: ["CTA"] */ "/workspace/tarbot/src/features/Landing/sections/CTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Features"] */ "/workspace/tarbot/src/features/Landing/sections/Features.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/workspace/tarbot/src/features/Landing/sections/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/workspace/tarbot/src/features/Landing/sections/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowItWorks"] */ "/workspace/tarbot/src/features/Landing/sections/HowItWorks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/workspace/tarbot/src/features/Landing/sections/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PainPoints"] */ "/workspace/tarbot/src/features/Landing/sections/PainPoints.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialProof"] */ "/workspace/tarbot/src/features/Landing/sections/SocialProof.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Solution"] */ "/workspace/tarbot/src/features/Landing/sections/Solution.tsx");
